document.addEventListener('DOMContentLoaded', function () {
    const formattedNumberInputs = document.querySelectorAll('.number-input-formatted');

    // Vyčistí hodnotu – povolí libovolné množství číslic za desetinnou tečkou
    function getRawValue(value) {
        if (!value) return '';

        let v = value.replace(/\s/g, '').replace(/,/g, '.');
        v = v.replace(/[^0-9.\-]/g, '');

        const firstDot = v.indexOf('.');
        if (firstDot !== -1) {
            v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
        }

        v = v.replace(/(?!^)-/g, '');

        return v;
    }

    // Formátování pro viditelný input (bez omezování desetinných míst)
    function formatNumberInput(value, locale) {
        const raw = getRawValue(value);

        if (raw === '' || raw === '-') return value;

        if (!/^-?\d*(\.\d*)?$/.test(raw)) return value;

        const [intPartRaw, decPart = ''] = raw.split('.');
        const isNegative = intPartRaw.startsWith('-');
        const intAbs = isNegative ? intPartRaw.slice(1) : intPartRaw;

        const intNumber = intAbs === '' ? 0 : parseInt(intAbs, 10);
        let formattedInt = intNumber.toLocaleString(locale);

        if (isNegative) {
            formattedInt = '-' + formattedInt;
        }

        if (decPart === '') return formattedInt;

        return `${formattedInt},${decPart}`;
    }

    formattedNumberInputs.forEach(input => {
        const locale = input.dataset.locale || 'cs-CZ';
        const decimalPlaces = input.dataset.decimals ? parseInt(input.dataset.decimals, 10) : null;

        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';

        const originalName = input.getAttribute('name');
        if (originalName) {
            hiddenInput.name = originalName;
            input.removeAttribute('name');
        } else {
            hiddenInput.name = input.id || '';
        }

        if (!input.id) {
            input.id = `numfmt-${Math.random().toString(36).slice(2)}`;
        }

        hiddenInput.id = `${input.id}-hidden`;
        input.parentNode.insertBefore(hiddenInput, input.nextSibling);

        const initialRaw = getRawValue(input.value || '');
        hiddenInput.value = initialRaw;

        let initialFormatted = formatNumberInput(initialRaw, locale);

        if (decimalPlaces !== null && initialRaw !== '' && initialRaw !== '-') {
            const num = parseFloat(initialRaw);
            if (!isNaN(num)) {
                initialFormatted = num.toLocaleString(locale, {
                    minimumFractionDigits: decimalPlaces,
                    maximumFractionDigits: decimalPlaces
                });
            }
        }

        input.value = initialFormatted;

        input.addEventListener('keydown', (e) => {
            const navKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Tab'];

            if (e.ctrlKey || e.metaKey || e.altKey) return;
            if (navKeys.includes(e.key)) return;

            if (e.key === ',' || e.key === '.') {
                if (e.target.value.includes(',') || e.target.value.includes('.')) {
                    e.preventDefault();
                    return;
                }

                e.preventDefault();

                const pos = input.selectionStart ?? input.value.length;
                input.value = input.value.slice(0, pos) + ',' + input.value.slice(pos);
                input.setSelectionRange(pos + 1, pos + 1);

                hiddenInput.value = getRawValue(input.value);
                return;
            }

            if (!/^\d$/.test(e.key) && e.key !== '-') {
                e.preventDefault();
                return;
            }

            if (e.key === '-') {
                if ((input.selectionStart ?? 0) !== 0 || input.value.indexOf('-') === 0) {
                    e.preventDefault();
                }
            }
        });

        input.addEventListener('paste', (e) => {
            e.preventDefault();
            const paste = (e.clipboardData || window.clipboardData).getData('text') || '';
            const sanitized = paste.replace(/[^0-9,\.\-]/g, '');

            const start = input.selectionStart ?? input.value.length;
            const end = input.selectionEnd ?? input.value.length;
            input.value = input.value.slice(0, start) + sanitized + input.value.slice(end);

            input.dispatchEvent(new Event('input', { bubbles: true }));
        });

        input.addEventListener('input', (e) => {
            const target = e.target;

            const cursorPosition = target.selectionStart ?? target.value.length;
            const rawValue = target.value;

            const formatted = formatNumberInput(rawValue, locale);
            target.value = formatted;

            hiddenInput.value = getRawValue(formatted);

            const diff = formatted.length - rawValue.length;
            const newCursor = Math.max(0, cursorPosition + diff);
            target.setSelectionRange(newCursor, newCursor);
        });

        input.addEventListener('blur', () => {
            let formatted = formatNumberInput(input.value, locale);

            if (decimalPlaces !== null) {
                const raw = getRawValue(formatted);
                if (raw !== '' && raw !== '-') {
                    const num = parseFloat(raw);
                    if (!isNaN(num)) {
                        formatted = num.toLocaleString(locale, {
                            minimumFractionDigits: decimalPlaces,
                            maximumFractionDigits: decimalPlaces
                        });
                    }
                }
            }

            input.value = formatted;
            hiddenInput.value = getRawValue(formatted);
        });
    });
});
